import { CommonModule } from '@angular/common'
import { Component, ElementRef, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'

@Component({
  selector: 'ddc-dic-s',
  templateUrl: './ddc-dic-s.component.html',
  styleUrl: './ddc-dic-s.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcDicSComponent {
  @Input() label: string

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(
    private logger: DdcLoggerService,
    public themeService: ThemeService,
    private el: ElementRef,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }
}
